import PreferredPartnersBookingMessage from './PreferredPartnersBookingMessage';

export default PreferredPartnersBookingMessage;
